export default "__VITE_ASSET__AsWhXnD9__"